import AppConstants from 'constants/AppConstants';

export function setQuery(query: Dictionary<string>): BaseTockAction {
  return {
    payload: query,
    type: AppConstants.SET_QUERIES,
  };
}
